// Owner-approved 2026-08-10: flat absolute tolerance (not a percentage) on
// cargo allocation per order line, in the line's own physical unit (m³/m²/szt.).
// Mirrored on the backend as transportService.CARGO_QUANTITY_TOLERANCE.
export const CARGO_QUANTITY_TOLERANCE = 0.5;

const CARGO_QUANTITY_EPSILON = 1e-6;

/**
 * Frontend mirror of the backend reservation rule used only for subtracting
 * the currently edited truck from server allocation hints. Active trucks use
 * their plan; a delivered truck uses the confirmed physical quantity; a
 * legacy delivered row without confirmation stays conservative.
 */
export function getEffectiveTransportReservationQuantity({
  status,
  quantity,
  deliveredQuantity,
}: {
  status?: string | null;
  quantity: number;
  deliveredQuantity?: number | null;
}): number {
  const plannedQuantity = Number.isFinite(Number(quantity))
    ? Math.max(Number(quantity), 0)
    : 0;
  const normalizedStatus = String(status || '').toUpperCase();

  if (normalizedStatus === 'CANCELLED') return 0;
  if (normalizedStatus !== 'DELIVERED' || deliveredQuantity == null) {
    return plannedQuantity;
  }

  const actualQuantity = Number(deliveredQuantity);
  if (!Number.isFinite(actualQuantity) || actualQuantity < 0) {
    return plannedQuantity;
  }
  // A confirmed over-delivery is allowed after the backend's audited
  // operational-exception flow. Keep the frontend mirror honest so editing a
  // delivered truck subtracts the full physical delivery, not its old plan.
  return actualQuantity;
}

/**
 * Mirrors the backend cumulative guard. A single-truck transport may use the
 * remaining order-line quantity plus the accepted absolute tolerance.
 */
export function isCargoOverAllocated(
  quantity: number,
  allocatedElsewhere: number,
  availableQuantity: number,
): boolean {
  return quantity + allocatedElsewhere
    > availableQuantity + CARGO_QUANTITY_TOLERANCE + CARGO_QUANTITY_EPSILON;
}
